<div class="banner driver-sos-details-banner">

  <div class="driver-sos-details-banner__header">
    <div  class="driver-sos-details-banner__header__text"
          [innerHTML]="'BANNER.DRIVER_SOS_DETAILS.header.text' | translate | safeHtml">
    </div>

    <button (click)="openPopup()" class="btn btn--secondary">
      {{ 'BANNER.DRIVER_SOS_DETAILS.header.buttonText' | translate }}&nbsp;>>
    </button>
  </div>

  <div class="driver-sos-details-banner__content">
    <ng-container *ngFor="let description of bannersService.driverSosDescriptionsConfig, let i = index">

      <app-driver-sos-description [descriptionConfig]="description">
      </app-driver-sos-description>

      <div  class="driver-sos-details-banner__content__arrow"
            *ngIf="i < bannersService.driverSosDescriptionsConfig.length - 1">
        <img [src]="arrowUrl" alt="">
      </div>
    </ng-container>
  </div>

</div>
